import { ComponentType, Suspense } from 'react';

import { ProgressBar } from './progress-bar';
import useScreenTracker from './use-screen-tracker';

const Loader = (Component: ComponentType, pageTitle?: string) => {
  const LoaderContent = () => {
    useScreenTracker(pageTitle);

    return (
      <Suspense fallback={<ProgressBar />}>
        <Component />
      </Suspense>
    );
  };
  LoaderContent.displayName = 'LoaderContent';
  return LoaderContent;
};

export default Loader;
